<div class="flex flex-col md:flex-row gap-4 items-start h-[calc(100vh-100px)]">
    <!-- Coluna Esquerda: Informações e Listagem (35%) -->
    <div class="w-full md:w-[30%] flex flex-col gap-4 h-full">
        <!-- Card Topo Esquerdo: Info da Demanda e Voltar -->
        <p-card styleClass="w-full h-auto shadow-sm">
            <div class="flex justify-between items-start">
                <div class="flex flex-col">
                    <span class="text-[10px] font-bold text-primary uppercase tracking-wider mb-2">Detalhamento da Demanda</span>
                    <div class="user-profile flex items-center gap-3 mt-2">
                        <div class="avatar-wrapper">
                            <p-avatar [image]="currentUser.image" size="xlarge" shape="circle"></p-avatar>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 m-0">{{ currentUser.name }}</h3>
                            <span class="text-slate-500">Solicitante</span>
                        </div>
                    </div>
                </div>
                <p-button label="Voltar" routerLink="/orientacoes" styleClass="p-button-outlined p-button-sm rounded-full text-primary border-primary hover:bg-primary-50 px-4"></p-button>
            </div>
        </p-card>

        <!-- Card Base Esquerdo: Listagem de Documentos -->
        <p-card styleClass="w-full flex-1 flex flex-col shadow-sm" [style]="{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: '0' }">
            <div class="flex flex-col h-full sidebar border-none w-full min-w-0 p-0">
                <h4 class="font-bold text-slate-700 dark:text-slate-200 mb-4 mt-0">Documentos da Demanda</h4>

                <div class="search-box mb-4">
                    <span class="p-input-icon-left w-full relative flex items-center">
                        <i class="pi pi-search absolute left-0 ms-3 text-slate-400"></i>
                        <input type="text" pInputText placeholder="Buscar documentos..." class="w-full" />
                    </span>
                    <p-button label="" icon="pi pi-filter" (click)="op.toggle($event)"></p-button>
                </div>

                <p-popover #op [dismissable]="false">
                    <div class="filter-content p-3" style="width: 300px">
                        <div class="mb-3">
                            <label class="block mb-2 font-bold text-sm">Data</label>
                            <p-date-picker [(ngModel)]="filterDate" dateFormat="dd/mm/yy" [showIcon]="true" [showOnFocus]="false" styleClass="w-full" appendTo="body"></p-date-picker>
                        </div>
                        <div class="mb-3">
                            <label class="block mb-2 font-bold text-sm">Status</label>
                            <p-select [options]="statusOptions" [(ngModel)]="filterStatus" optionLabel="label" optionValue="value" placeholder="Selecione" [showClear]="true" styleClass="w-full" appendTo="body"></p-select>
                        </div>
                        <div class="mb-3">
                            <label class="block mb-2 font-bold text-sm">Remetente</label>
                            <app-estado-select [(uf)]="filterUf"></app-estado-select>
                        </div>
                        <div class="mb-3">
                            <label class="block mb-2 font-bold text-sm">Texto da Mensagem</label>
                            <input pInputText [(ngModel)]="filterMessage" placeholder="Texto da mensagem" class="w-full" />
                        </div>
                        <div class="flex justify-content-between mt-3">
                            <p-button label="Limpar" styleClass="p-button-text p-button-sm" (onClick)="clearFilters()"></p-button>
                            <div class="flex gap-2">
                                <p-button label="Fechar" styleClass="p-button-text p-button-sm" (onClick)="op.hide()"></p-button>
                                <p-button label="Aplicar" styleClass="p-button-sm" (onClick)="applyFilters(); op.hide()"></p-button>
                            </div>
                        </div>
                    </div>
                </p-popover>

                <div class="contact-list overflow-y-auto flex-1 pr-2">
                    @for (contact of filteredContacts(); track contact) {
                        <div
                            class="contact-item p-3 border border-slate-200 dark:border-slate-700 rounded-xl mb-3 cursor-pointer transition-colors hover:bg-slate-50 dark:hover:bg-slate-800"
                            [class.active]="contact.id === activeContact().id"
                            (click)="selectContact(contact)"
                        >
                            <div class="flex items-start gap-3 w-full">
                                <div class="doc-icon p-2 bg-slate-100 dark:bg-slate-800 rounded-lg text-slate-500 shrink-0">
                                    <i class="pi pi-file-pdf text-xl"></i>
                                </div>
                                <div class="flex-1 min-w-0">
                                    <div class="flex justify-between items-start mb-1">
                                        <span class="font-bold text-slate-700 dark:text-slate-200 truncate pr-2">{{ contact.name }}</span>
                                        <span class="text-[10px] text-slate-400 whitespace-nowrap">{{ contact.date | date: 'dd/MM/yyyy' }}</span>
                                    </div>
                                    <p class="text-slate-500 truncate m-0">{{ contact.lastMessage }}</p>
                                    <div class="mt-2 flex gap-2">
                                        <span class="doc-badge text-[10px] px-2 py-0.5 rounded bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300">PDF</span>
                                        <span class="doc-badge text-[10px] px-2 py-0.5 rounded bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300">2.4 MB</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </p-card>
    </div>

    <!-- Coluna Direita: Chat Area (65%) -->
    <div class="flex-1 w-full min-w-0 h-full">
        <div class="grid-debitos w-full h-full">
            <p-card class="w-full h-full flex flex-col shadow-sm" styleClass="flex-1 flex flex-col h-100" [style]="{ display: 'flex', flexDirection: 'column', height: '100%' }">
                <div class="flex flex-col chat-area">
                    <div class="chat-header">
                        <div class="header-left">
                            <div class="contact-avatar">
                                <p-avatar [image]="activeContact().image" size="large" shape="circle"></p-avatar>
                                <span class="status-dot" [ngClass]="activeContact().status"></span>
                            </div>
                            <div class="header-info">
                                <h4>
                                    {{ activeContact().name }}
                                    @if (activeContact().statusLabel) {
                                        <span class="status-badge" [ngClass]="getBadgeClass(activeContact().statusLabel)">
                                            {{ activeContact().statusLabel }}
                                        </span>
                                    }
                                    <span class="chat-id-badge" title="ID do chat">ID: {{ activeContact().id }}</span>
                                </h4>
                                <span class="text-xs text-slate-500">Última atividade há 1 hora</span>
                            </div>
                        </div>
                        <div class="header-actions">
                            <app-botao-acoes [items]="actionItems"></app-botao-acoes>
                        </div>
                    </div>

                    <div class="message-list h-100 flex-1 overflow-y-auto chat-bg min-h-0 rounded-xl">
                        @for (msg of messages(); track msg) {
                            <div class="message-wrapper" [ngClass]="msg.owner">
                                @if (msg.owner === 'other') {
                                    <p-avatar [image]="activeContact().image" shape="circle" class="msg-avatar"></p-avatar>
                                }
                                <div class="message-row">
                                    @if (msg.owner === 'me') {
                                        <div class="message-time">
                                            <span>{{ msg.createdAt }}</span>
                                        </div>
                                    }
                                    <div class="message-content">
                                        <div class="message-bubble bg-gray-300 dark:bg-gray-600 text-gray-700 dark:text-white cursor-pointer" (click)="responderMensagem(msg)">
                                            {{ msg.text }}
                                        </div>
                                    </div>
                                    @if (msg.owner === 'other') {
                                        <div class="message-time">
                                            <span>{{ msg.createdAt }}</span>
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                    </div>

                    <div class="chat-input-area flex items-center gap-2 p-6">
                        <input type="text" pInputText class="chat-input flex-1 me-4" placeholder="Escreva uma mensagem" [(ngModel)]="newMessage" (keydown.enter)="sendMessage()" />

                        <label for="fileInput" class="py-2 px-3 cursor-pointer rounded-lg border border-gray-300 dark:border-gray-700">
                            <i class="pi pi-paperclip"></i>
                        </label>
                        <label for="imageInput" class="py-2 px-3 cursor-pointer rounded-lg border border-gray-300 dark:border-gray-700">
                            <i class="pi pi-image"></i>
                        </label>
                        <input type="file" id="fileInput" class="hidden" (change)="onFileChange($event)" />
                        <input type="file" id="imageInput" class="hidden" accept="image/*" (change)="onImageChange($event)" />

                        <span class="mb-1 ms-1 me-4 text-gray-400 dark:text-gray-500">|</span>

                        <p-button label="Send" icon="pi pi-send" class="p-button-primary send-btn" (click)="sendMessage()"></p-button>
                    </div>
                </div>
            </p-card>
        </div>
    </div>
    <app-compose-email-orientacoes [visible]="showCompose()" (visibleChange)="showCompose.set($event)" [remetente]="composeRemetente()" [messageTitle]="selectedMessageTitle()"></app-compose-email-orientacoes>
    <app-inserir-tarefa-orientacoes [visible]="showInserirTarefa()" (visibleChange)="showInserirTarefa.set($event)"></app-inserir-tarefa-orientacoes>
</div>
